import { useCallback, useMemo } from 'react';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../../config/config';
import { EnabledChains } from '../../../config/constants';
import useLiquidityPools from './useLiquidityPools';
// import useTokenDetails from '../useTokenDetails';
import { UserTotalWithdrawals } from './useUserTotalWithdrawals';

const mockWithdrawals: Record<
    string,
    { totalAssetWithdrawn: string; totalLpWithdrawn: string }
> = {
    blueChip: { totalAssetWithdrawn: '3200.50', totalLpWithdrawn: '850.25' },
    altCoin: { totalAssetWithdrawn: '1500.00', totalLpWithdrawn: '420.00' },
    degen: { totalAssetWithdrawn: '800.00', totalLpWithdrawn: '250.00' },
};

const useMockUserTotalWithdrawals = () => {
    const { chainId } = useWeb3React();
    const { liquidityPools } = useLiquidityPools();
    // const { decimals } = useTokenDetails(
    //     config.addresses[chainId as EnabledChains[number]]?.collateral
    // );

    const userTotalWithdrawals = useMemo(() => {
        if (!liquidityPools) return undefined;

        let totalWithdrawnAssetAllPools = '0';
        let totalWithdrawnLpAllPools = '0';

        const totalWithdrawalsPerPool = liquidityPools.map((liquidityPool) => {
            // const shareDecimals = liquidityPool.decimals;

            let poolKey: string | undefined;
            if (
                liquidityPool.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.blueChip?.toLowerCase()
            ) {
                poolKey = 'blueChip';
            } else if (
                liquidityPool.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.altCoin?.toLowerCase()
            ) {
                poolKey = 'altCoin';
            } else if (
                liquidityPool.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.degen?.toLowerCase()
            ) {
                poolKey = 'degen';
            }

            const withdrawalData = poolKey ? mockWithdrawals[poolKey] : null;
            const totalAssetWithdrawn = withdrawalData?.totalAssetWithdrawn ?? '0';
            const totalLpWithdrawn = withdrawalData?.totalLpWithdrawn ?? '0';

            if (withdrawalData) {
                totalWithdrawnAssetAllPools = (
                    parseFloat(totalWithdrawnAssetAllPools) +
                    parseFloat(totalAssetWithdrawn)
                ).toString();
                totalWithdrawnLpAllPools = (
                    parseFloat(totalWithdrawnLpAllPools) + parseFloat(totalLpWithdrawn)
                ).toString();
            }

            return {
                liquidityPool,
                totalAssetWithdrawn,
                totalLpWithdrawn,
            } as UserTotalWithdrawals;
        });

        return {
            totalWithdrawalsPerPool,
            totalWithdrawnAsset: totalWithdrawnAssetAllPools,
            totalWithdrawnLp: totalWithdrawnLpAllPools,
        };
    }, [liquidityPools, chainId]);

    const updateUserTotalWithdrawals = useCallback(() => {}, []);

    return {
        userTotalWithdrawals,
        isLoading: false,
        error: undefined,
        updateUserTotalWithdrawals,
    };
};

export default useMockUserTotalWithdrawals;
